import React, { useState } from 'react'
import {
	TableRowContainer,
	TableLinkRowContainer,
	TableLinkTdwContainer,
} from './Style'
import consoleLog from 'shared/utils/consoleLog'
import TdwContainer from './TdwContainer'

// interface RowProps {}
const TableRow = ({
	data,
	headData,
	hoverLink,
	clickFunction,
	serialNumber,
	index: rowIndex,
}: any) => {
	const Container = hoverLink ? TableLinkRowContainer : TableRowContainer

	const [showMore, setShowMore] = useState()

	const hoverClick = (elm: any) => {
		if (hoverLink) {
			// consoleLog(elm);
		}
	}

	return (
		<Container>
			{serialNumber && (
				<TableLinkTdwContainer
					key={`sn${rowIndex}`}
					onClick={() => clickFunction(data)}>
					{++rowIndex}
				</TableLinkTdwContainer>
			)}
			{headData?.map((item: any, index: any) => {
				//console.log('item:', item)
				let showMore = false
				return (
					<TdwContainer
						data={data}
						item={item}
						key={item.id}
						onClick={() => clickFunction(data)}
					/>
				)
			})}
		</Container>
	)
}

export default TableRow
